import React, { Fragment } from "react";

import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { AnimatePresence, m } from "motion/react";

import { Icon } from "src/design-system/Icon";

type Props = {
  title: React.ReactNode;
  children: React.ReactNode;
  dataLoc?: string;
};

export const AccordionItem: React.FC<Props> = ({
  title,
  children,
  dataLoc,
}) => (
  <Disclosure as="div" data-loc={dataLoc}>
    {({ open }) => (
      <>
        <div className="mb-3.5 flex w-full items-center gap-x-2 font-inter-semibold-13px text-gray-800">
          <DisclosureButton
            className="group"
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
          >
            <div className="-rotate-90 transition-transform duration-300 group-data-[open]:rotate-0">
              <Icon icon={faChevronDown} size="xs" variant="hover" />
            </div>
          </DisclosureButton>
          {title}
        </div>
        <AnimatePresence initial={false}>
          {open && (
            <DisclosurePanel as={Fragment} static>
              <m.div
                animate={{
                  height: "auto",
                  opacity: 1,
                  overflow: "hidden",
                  transitionEnd: { overflow: "visible" },
                }}
                exit={{ height: 0, opacity: 0, overflow: "hidden" }}
                initial={{ height: 0, opacity: 0, overflow: "hidden" }}
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                <div className="flex flex-col gap-y-3">{children}</div>
              </m.div>
            </DisclosurePanel>
          )}
        </AnimatePresence>
      </>
    )}
  </Disclosure>
);
